/**
 * Age Gate
 * Full-screen consent overlay for the NSFW site.
 * Consent is stored in localStorage — shown only once per browser.
 */

const STORAGE_KEY = 'anilora_nsfw_verified';

function createGateHTML() {
  return `
    <div id="age-gate" class="age-gate">
      <div class="age-gate__backdrop"></div>
      <div class="age-gate__card">
        <div class="age-gate__icon">🔞</div>
        <h1 class="age-gate__title">Adults Only</h1>
        <p class="age-gate__subtitle">
          You are about to enter <strong>Anilora NSFW</strong> — a site containing
          explicit adult content including nudity and mature themes.
        </p>
        <p class="age-gate__warning">
          By entering you confirm that you are <strong>18 years of age or older</strong>
          and that viewing adult content is legal in your jurisdiction.
        </p>
        <div class="age-gate__actions">
          <button id="age-gate-enter" class="age-gate__btn age-gate__btn--enter">
            I am 18+ &mdash; Enter
          </button>
          <button id="age-gate-leave" class="age-gate__btn age-gate__btn--leave">
            Leave
          </button>
        </div>
        <p class="age-gate__legal">
          This site uses cookies to remember your age verification.
        </p>
      </div>
    </div>
  `;
}

function injectStyles() {
  const style = document.createElement('style');
  style.textContent = `
    .age-gate {
      position: fixed;
      inset: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    }

    .age-gate__backdrop {
      position: absolute;
      inset: 0;
      background: radial-gradient(
        ellipse at 50% 40%,
        #2d0018 0%,
        #0a0008 60%,
        #000 100%
      );
    }

    .age-gate__card {
      position: relative;
      z-index: 1;
      max-width: 480px;
      width: 100%;
      background: rgba(21, 0, 15, 0.85);
      border: 1px solid rgba(255, 45, 122, 0.25);
      border-radius: 1.5rem;
      padding: 2.5rem 2rem;
      text-align: center;
      backdrop-filter: blur(24px);
      box-shadow:
        0 0 0 1px rgba(255, 45, 122, 0.1),
        0 25px 50px -12px rgba(0, 0, 0, 0.9),
        0 0 60px rgba(255, 45, 122, 0.15);
      animation: gate-in 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    @keyframes gate-in {
      from { opacity: 0; transform: scale(0.9) translateY(20px); }
      to   { opacity: 1; transform: scale(1) translateY(0); }
    }

    .age-gate__icon {
      font-size: 3rem;
      margin-bottom: 1rem;
      filter: drop-shadow(0 0 12px rgba(255, 45, 122, 0.5));
    }

    .age-gate__title {
      font-size: 2rem;
      font-weight: 800;
      background: linear-gradient(135deg, #ff2d7a, #bf40ff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin: 0 0 1rem;
    }

    .age-gate__subtitle {
      color: #c8a0b8;
      font-size: 0.95rem;
      line-height: 1.6;
      margin: 0 0 0.75rem;
    }

    .age-gate__subtitle strong,
    .age-gate__warning strong {
      color: #fde8f2;
    }

    .age-gate__warning {
      color: #9a6080;
      font-size: 0.85rem;
      line-height: 1.5;
      margin: 0 0 1.75rem;
      padding: 0.75rem 1rem;
      background: rgba(255, 45, 122, 0.06);
      border-radius: 0.75rem;
      border: 1px solid rgba(255, 45, 122, 0.12);
    }

    .age-gate__actions {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
    }

    .age-gate__btn {
      width: 100%;
      padding: 0.875rem 1.5rem;
      border-radius: 9999px;
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      border: none;
      transition: all 0.2s ease;
    }

    .age-gate__btn--enter {
      background: linear-gradient(135deg, #ff2d7a, #d4005e);
      color: #fff;
      box-shadow: 0 4px 20px rgba(255, 45, 122, 0.4);
    }

    .age-gate__btn--enter:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 30px rgba(255, 45, 122, 0.6);
      filter: brightness(1.1);
    }

    .age-gate__btn--leave {
      background: transparent;
      color: #7a4560;
      border: 1px solid #320018;
    }

    .age-gate__btn--leave:hover {
      color: #c49aad;
      border-color: #520028;
      background: rgba(255, 45, 122, 0.05);
    }

    .age-gate__legal {
      margin-top: 1.25rem;
      color: #4a2035;
      font-size: 0.75rem;
    }

    /* Prevent scroll while gate is visible */
    body.age-gate-active {
      overflow: hidden;
    }
  `;
  document.head.appendChild(style);
}

export function initAgeGate() {
  if (localStorage.getItem(STORAGE_KEY) === 'true') return;

  injectStyles();
  document.body.insertAdjacentHTML('afterbegin', createGateHTML());
  document.body.classList.add('age-gate-active');

  document.getElementById('age-gate-enter').addEventListener('click', () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    const gate = document.getElementById('age-gate');
    gate.style.opacity = '0';
    gate.style.transition = 'opacity 0.3s ease';
    setTimeout(() => {
      gate.remove();
      document.body.classList.remove('age-gate-active');
    }, 300);
  });

  document.getElementById('age-gate-leave').addEventListener('click', () => {
    window.location.href = 'https://www.google.com';
  });
}
